'use client';
import { FAQItem } from '@/lib/strapi-fetcher';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const Faq = ({ faqData }: { faqData: FAQItem['faqs'] }) => {
  return (
    <Accordion type="single" collapsible className="w-full px-0">
      {faqData.map((item, index) => (
        <AccordionItem key={index} value={String(index)}>
          <AccordionTrigger className="py-3">
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="py-0 text-sm text-muted-foreground">
            <div className="pb-4">{item.answer}</div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default Faq;
